import { Animated } from "react-native";
import { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { useTheme } from "styled-components/native";
import { SwitchProps } from "./types";
import styled from "styled-components/native";
import { SpaceType } from "../Spacer/types";

const VDBSwitch = ({ value, onValueChange }: SwitchProps) => {
  const [animatedValue] = useState(new Animated.Value(value ? 1 : 0));
  const theme = useTheme();

  useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: value ? 1 : 0,
      duration: 200, // Adjust the animation duration
      useNativeDriver: false,
    }).start();
  }, [value]);

  const translateX = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [4, 24], // Adjust the distance of the switch head
  });

  const toggleSwitch = () => {
    const newValue = !value;
    onValueChange(newValue);
  };

  const currentStyles = value
    ? {
        bgGradientColors: [theme["toggle-bg-on"], theme["toggle-bg-on"]],
        headGradientColors: [theme["toggle-cont"], theme["toggle-cont"]],
      }
    : {
        bgGradientColors: [
          theme["toggle-bg-static"],
          theme["toggle-bg-static"],
        ],
        headGradientColors: [theme["toggle-cont"], theme["toggle-cont"]],
      };

  return (
    <Container onPress={toggleSwitch}>
      <LinearBackGround
        colors={currentStyles.bgGradientColors}
        start={{
          x: 0,
          y: 0.5,
        }}
      >
        <InnerContainer>
          <Animated.View
            style={{
              transform: [{ translateX }],
            }}
          >
            <SwitchHead colors={currentStyles.headGradientColors} />
          </Animated.View>
        </InnerContainer>
      </LinearBackGround>
    </Container>
  );
};

export default VDBSwitch;

const Container = styled.Pressable`
  width: 44px;
  height: 24px;
  border-radius: ${SpaceType.large}px;
`;

const LinearBackGround = styled(LinearGradient)`
  border-radius: ${SpaceType.large}px;
  flex: 1;
`;

const InnerContainer = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
  position: relative;
`;

const SwitchHead = styled(LinearGradient)`
  width: ${SpaceType.Double}px;
  height: ${SpaceType.Double}px;
  border-radius: 100px;
`;
